import React from 'react';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import StatModule from '@nmx/template/dist/componentLibrary/modules/StatModule';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import CardImage from './images/73-percent-graphic.png';

export default () => (
  <StatModule
    sectionId='retirement-planning'
    headingText={<>Live well now and <WidowBlock>in retirement.</WidowBlock></>}
    descriptionText={(
      <>
        At Northwestern Mutual, we&#39;ll help make sure you have the right tax&#45;efficient income strategies and financial protection needed to retire the way you&#39;ve always dreamed of. From{' '}
        <Link
          id='retirement-planning-stat-module-401k-link'
          variant='primaryDeemphasize'
          linkUrl='/401k-plans/'>
          401(k)s
        </Link>
        ,{' '}
        <Link
          id='retirement-planning-stat-module-ira-link'
          variant='primaryDeemphasize'
          linkUrl='/iras-and-retirement-plans/'>
          IRAs
        </Link>
        ,{' '}
        <Link
          id='retirement-planning-stat-module-investments-link'
          variant='primaryDeemphasize'
          linkUrl='/investments/'>
          investments
        </Link>
        {' '}and{' '}
        <Link
          id='retirement-planning-stat-module-annuities-link'
          variant='primaryDeemphasize'
          linkUrl='/annuities/'>
          annuities
        </Link>
        {' '}to the right types of{' '}
        <Link
          id='retirement-planning-stat-module-insurance-link'
          variant='primaryDeemphasize'
          linkUrl='/insurance/'>
          insurance
        </Link>
        , we&#39;ll help you maximize your savings, build more wealth, create a guaranteed income stream, and protect you from the unexpected. That way, you can make the most of your retirement while still enjoying your life today.
      </>
    )}
    moduleName='stat-module'
    moduleVariation='A'
    ctaPrimary={{
      linkId: 'retirement-planning-product-intro-cta-button',
      linkUrl: '/find-a-financial-advisor/',
      linkText: 'Get started',
      ariaLabel: 'Start planning for your retirement with a financial advisor',
      children: '',
    }}
    ctaSecondary={{
      linkUrl: '',
      children: '',
    }}
    cardImage={CardImage}
    cardImageAltText='seventy three percent graphic'
    cardDescriptionText={<>of Americans who work with an advisor say they have clarity on how much to spend now and save for later.<sup>1</sup></>}
    cardDescriptionTextAriaLabel='Seventy three percent of Americans who work with an advisor say they have clarity on how much to spend now and save for later.'
  />
);
